import Enlang from './entries/en-US';
import Falang from './entries/fa_IR';
import { addLocaleData } from 'react-intl';


const AppLocale = {
  en: Enlang,
  fa: Falang,
};
addLocaleData(AppLocale.en.data);
addLocaleData(AppLocale.fa.data);

export default AppLocale;
